import React from 'react';

import { Icon, IconButton } from '@/components';
import { useDeleteFavorites, usePostFavorite } from '@/hooks';
import Heart from '@/svgs/products/heart.svg';
import { googleEventAddWishlist } from '@/utils/googleAnalyticsEvent';

const LikeButton: React.FC<{
  userFavoriteProductId: string | null;
  code: number;
  itemId: string;
  price: number;
  discountPrice: number;
  title: string;
}> = ({ userFavoriteProductId, code, itemId, price, discountPrice, title }) => {
  const { mutateAsync: setLike } = usePostFavorite();
  const { mutateAsync: deleteLike } = useDeleteFavorites();
  const [favoriteProduct, setFavoriteProduct] = React.useState<string | null>(
    userFavoriteProductId || null
  );

  return (
    <>
      <IconButton
        variant="none"
        border="none"
        aria-label="favorite"
        icon={
          <Icon
            as={Heart}
            width={{ base: '16px', md: '26px' }}
            height={{ base: '14px', md: '23px' }}
            fill={favoriteProduct ? 'primary.500' : 'transparent'}
            stroke={favoriteProduct ? 'primary.500' : 'black'}
            strokeWidth={2}
          />
        }
        onClick={() => {
          if (favoriteProduct) {
            void deleteLike({
              id: favoriteProduct,
            }).then(() => setFavoriteProduct(null));
          } else {
            void setLike({
              product_group_code: code,
            }).then((res) => {
              setFavoriteProduct(res.id);
              googleEventAddWishlist({
                itemId: itemId,
                title: title,
                price: price,
                discount: discountPrice,
              });
            });
          }
        }}
      />
    </>
  );
};
export default LikeButton;
